var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPainImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.9949 12.4137C23.7972 19.0735 18.2753 24.3082 11.6489 24.1163C5.02256 23.9176 -0.185799 18.361 0.00508349 11.708C0.202783 5.04826 5.72474 -0.193229 12.3511 0.00546764C18.9774 0.197313 24.1858 5.75397 23.9949 12.4137Z",
    fill: "#82E05D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5837 0.923647C15.6105 1.01272 18.317 2.28027 20.3008 4.26724C18.2897 1.98565 15.3719 0.505698 12.0997 0.409776C5.80055 0.224782 0.544468 5.20591 0.360403 11.5368C0.264962 14.8256 1.56024 17.8334 3.70767 19.9917C1.85338 17.8883 0.755802 15.0928 0.844426 12.0507C1.02849 5.71978 6.28458 0.738653 12.5837 0.923647Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.5,
    d: "M23.0208 12.1124C23.1094 9.07715 22.0119 6.28168 20.1508 4.17139C22.305 6.32965 23.6003 9.33066 23.5049 12.6263C23.3208 18.9572 18.0647 23.9383 11.7656 23.7533C8.48649 23.6574 5.57554 22.1774 3.56445 19.8958C5.54827 21.8828 8.26153 23.1504 11.2816 23.2394C17.5807 23.4244 22.8368 18.4433 23.0208 12.1124Z",
    fill: "#6F6F6E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.5,
    d: "M15.5813 6.67244C14.6405 6.64503 13.8565 7.61796 13.8156 8.85125C13.7815 10.0845 14.511 11.1054 15.4449 11.1328C16.3857 11.1603 17.1697 10.1873 17.2038 8.95403C17.2379 7.72074 16.5152 6.69985 15.5813 6.67244Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.5,
    d: "M9.05088 11.1807C9.98484 11.2081 10.7756 10.2352 10.8097 9.00186C10.8438 7.77542 10.1144 6.75453 9.18041 6.72713C8.23963 6.69972 7.45565 7.67265 7.42156 8.90594C7.38066 10.1324 8.1101 11.1533 9.05088 11.1807Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.5,
    d: "M15.1047 4.1303C16.359 4.32215 17.0748 5.71988 17.0748 5.71988C17.0748 5.71988 16.8158 3.7055 15.0569 3.43144C13.2981 3.15052 13.0322 6.10357 13.0322 6.10357C13.0322 6.10357 13.6049 3.89735 15.1047 4.1303Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.5,
    d: "M9.34407 4.96636C10.5303 4.95951 10.8984 6.12428 10.8984 6.12428C10.8984 6.12428 10.7689 4.2675 9.41906 4.44564C8.06243 4.62378 7.68066 6.4052 7.68066 6.4052C7.68066 6.4052 8.30785 4.97321 9.34407 4.96636Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.4902 14.579C17.4902 14.5448 17.4902 14.5037 17.4902 14.4694C17.4971 14.4625 17.4902 14.5105 17.4902 14.579Z",
    fill: "#1392B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.5,
    d: "M19.6118 10.5708C18.7051 10.5434 17.9621 10.9133 17.9484 11.3998C17.9348 11.8863 18.6574 12.3042 19.5573 12.3316C20.4572 12.359 21.2071 11.9822 21.2207 11.5026C21.2343 11.0093 20.5185 10.5982 19.6118 10.5708Z",
    fill: "#6F6F6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.5,
    d: "M6.31053 11.3517C6.32417 10.8652 5.60154 10.4473 4.69485 10.4199C3.78815 10.3925 3.04507 10.7693 3.03144 11.2489C3.01781 11.7354 3.74043 12.1533 4.64713 12.1807C5.55382 12.2081 6.2969 11.8381 6.31053 11.3517Z",
    fill: "#6F6F6E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.8224 8.67279C13.7884 9.90608 14.5178 10.927 15.4518 10.9544C16.3925 10.9818 17.1765 10.0089 17.2106 8.77556C17.2447 7.54227 16.5152 6.52138 15.5813 6.49397C14.6473 6.47342 13.8565 7.44635 13.8224 8.67279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M7.42107 8.72772C7.38698 9.96101 8.11643 10.9819 9.05039 11.0025C9.99116 11.0299 10.7751 10.0569 10.8092 8.82364C10.8433 7.59035 10.1139 6.57631 9.17992 6.5489C8.24596 6.5215 7.45516 7.49443 7.42107 8.72772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M17.0748 5.54166C17.0748 5.54166 16.8158 3.53413 15.0569 3.25322C13.2981 2.9723 13.0322 5.92535 13.0322 5.92535C13.0322 5.92535 13.6049 3.72598 15.1047 3.95893C16.359 4.15078 17.0748 5.54166 17.0748 5.54166Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M10.9052 5.94606C10.9052 5.94606 10.7757 4.08927 9.4259 4.26742C8.06927 4.44556 7.6875 6.22698 7.6875 6.22698C7.6875 6.22698 8.31469 4.78814 9.35091 4.78814C10.5371 4.78814 10.9052 5.94606 10.9052 5.94606Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M17.4971 14.4009C17.5107 14.7709 17.6812 15.9905 19.4195 16.5797C19.4195 16.5797 17.4903 16.7784 17.4971 14.4009Z",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M5.75071 15.0108C5.76434 15.1409 5.79161 15.3259 5.83933 15.5657C5.88705 15.8055 5.96204 16.0865 6.0643 16.4016C6.11884 16.5592 6.18701 16.7237 6.25518 16.9018C6.33699 17.0731 6.4188 17.2512 6.51424 17.4294C6.62331 17.6007 6.71876 17.7925 6.84828 17.9707C6.91646 18.0597 6.98462 18.1488 7.04598 18.2379C7.11415 18.3338 7.18233 18.4229 7.26414 18.5051C7.42775 18.6695 7.57772 18.8614 7.78224 18.9984C7.87768 19.0806 7.97312 19.156 8.06856 19.2382C8.15719 19.3204 8.2799 19.3752 8.38216 19.4438C8.49124 19.5123 8.59349 19.5808 8.70939 19.6493C8.81846 19.7178 8.94117 19.7589 9.05707 19.8137C9.17296 19.8686 9.29567 19.9234 9.41838 19.9782C9.54109 20.033 9.67062 20.0604 9.79333 20.1015C10.291 20.2796 10.8432 20.355 11.3681 20.4304C11.6408 20.4509 11.9203 20.4715 12.193 20.4852C12.4589 20.4852 12.7247 20.4578 12.9906 20.4441C13.2565 20.4235 13.5087 20.355 13.7678 20.3139C14.02 20.2591 14.2586 20.1563 14.504 20.081C14.7358 19.985 14.954 19.8548 15.1721 19.7589C15.3766 19.6219 15.5812 19.4986 15.7652 19.3615C16.1265 19.0738 16.4469 18.7586 16.706 18.4434C16.8287 18.2858 16.9582 18.1282 17.0537 17.9707C17.1628 17.8199 17.2582 17.6692 17.34 17.5184C17.4286 17.3746 17.5036 17.2375 17.565 17.1074C17.6331 16.9772 17.6877 16.8538 17.7354 16.7442C17.8308 16.525 17.899 16.3468 17.9467 16.2235C17.9945 16.1002 18.0217 16.0385 18.0217 16.0385C18.0217 16.0385 17.9945 16.1002 17.9604 16.2235C17.9195 16.3468 17.8717 16.5318 17.7763 16.7579C17.7354 16.8744 17.6877 16.9977 17.6263 17.1279C17.5718 17.2649 17.5036 17.4088 17.4218 17.5596C17.3468 17.7103 17.2582 17.8679 17.1559 18.0323C17.0605 18.2036 16.9378 18.3612 16.8151 18.5256C16.5628 18.8614 16.2492 19.1902 15.8811 19.5054C15.6902 19.6562 15.4857 19.7932 15.2744 19.9371C15.0494 20.0535 14.8244 20.1837 14.579 20.2865C14.3268 20.3687 14.0814 20.4783 13.8155 20.54C13.5496 20.588 13.2837 20.6633 13.0042 20.6907C12.7316 20.7045 12.4452 20.7387 12.1657 20.7387C11.893 20.725 11.6135 20.7113 11.3408 20.6907C10.775 20.6085 10.2296 20.5195 9.7047 20.3276C9.57517 20.2797 9.43883 20.2522 9.31612 20.1906C9.19341 20.1358 9.0707 20.0741 8.94799 20.0193C8.82528 19.9576 8.70257 19.9097 8.58668 19.8411C8.47078 19.7658 8.36171 19.6973 8.25263 19.6219C8.02085 19.4917 7.82996 19.3204 7.63908 19.1491C7.43456 18.9915 7.28458 18.7929 7.12097 18.6147C7.03916 18.5325 6.96417 18.4366 6.90282 18.3338C6.83465 18.2379 6.76647 18.1419 6.70512 18.046C6.57559 17.861 6.48697 17.6555 6.37789 17.4773C6.28927 17.2855 6.20746 17.1005 6.13929 16.9292C6.08475 16.7442 6.0234 16.5729 5.97567 16.4085C5.88705 16.0796 5.83251 15.7918 5.79161 15.552C5.75753 15.3122 5.74389 15.1204 5.74389 14.9902C5.74389 14.86 5.74389 14.7915 5.74389 14.7915C5.74389 14.7915 5.73708 14.8874 5.75071 15.0108Z",
    fill: "#161615"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M17.9553 11.2284C17.9416 11.7149 18.6643 12.1328 19.571 12.1602C20.4708 12.1876 21.2207 11.8108 21.2344 11.3243C21.248 10.8379 20.5254 10.4199 19.6255 10.3925C18.712 10.3651 17.9689 10.742 17.9553 11.2284Z",
    fill: "#F7C3C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M3.03828 11.0775C3.02464 11.564 3.74727 11.982 4.64714 12.0094C5.55383 12.0368 6.29691 11.6668 6.31055 11.1803C6.32418 10.6939 5.60156 10.2759 4.70168 10.2485C3.80181 10.2211 3.05191 10.5911 3.03828 11.0775Z",
    fill: "#F7C3C0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M10.0197 8.80221C9.99929 9.34348 9.65161 9.77514 9.24258 9.76143C8.82672 9.74773 8.50632 9.30237 8.51995 8.75424C8.53359 8.21297 8.88126 7.78131 9.29711 7.78817C9.71297 7.80872 10.0334 8.25408 10.0197 8.80221Z",
    fill: "#2E140B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M9.16139 8.36342C9.15458 8.5073 9.06595 8.62378 8.95688 8.61693C8.8478 8.61693 8.75918 8.4936 8.76599 8.34972C8.77281 8.20583 8.86144 8.08936 8.97051 8.08936C9.07959 8.10306 9.16139 8.21954 9.16139 8.36342Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M16.1418 8.7072C16.1282 9.24847 15.7737 9.68013 15.3646 9.67327C14.9488 9.65957 14.6284 9.20736 14.642 8.66609C14.6557 8.12481 15.0033 7.69316 15.4192 7.70686C15.835 7.71371 16.1554 8.16592 16.1418 8.7072Z",
    fill: "#2E140B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M15.2835 8.27531C15.2766 8.4192 15.188 8.53567 15.079 8.52882C14.9699 8.52882 14.8812 8.40549 14.8881 8.26161C14.8881 8.11773 14.9835 8.00125 15.0926 8.0081C15.1948 8.0081 15.2835 8.12458 15.2835 8.27531Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPainImage);
export default __webpack_public_path__ + "static/media/NoPainImage.4cfbe3a22c19bb5e3903c1b5e86f64d7.svg";
export { ForwardRef as ReactComponent };